document.addEventListener('DOMContentLoaded', function () {

  // ── Slideshow ──────────────────────────────────────
  const slides = document.querySelectorAll('.slide');
  const dots   = document.querySelectorAll('.slide-dot');
  let cur = 0, timer;

  function goTo(n) {
    slides[cur]?.classList.remove('active');
    dots[cur]?.classList.remove('active');
    cur = (n + slides.length) % slides.length;
    slides[cur]?.classList.add('active');
    dots[cur]?.classList.add('active');
  }
  if (slides.length > 0) {
    goTo(0);
    timer = setInterval(() => goTo(cur + 1), 5000);
    document.querySelectorAll('.slide-arrow').forEach(b => b.addEventListener('click', () => { goTo(cur + (b.dataset.dir === 'next' ? 1 : -1)); clearInterval(timer); timer = setInterval(() => goTo(cur + 1), 5000); }));
    dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); clearInterval(timer); timer = setInterval(() => goTo(cur + 1), 5000); }));
  }

  // ── Collection Tabs ────────────────────────────────
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.featured-collections');
      wrap.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      wrap.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      wrap.querySelector('[data-tab="' + btn.dataset.tab + '"]')?.classList.add('active');
    });
  });

  // ── Scroll Buttons ────────────────────────────────
  document.querySelectorAll('.products-scroll-wrap').forEach(wrap => {
    const track = wrap.querySelector('.products-scroll');
    wrap.querySelector('.scroll-btn-prev')?.addEventListener('click', () => track.scrollBy({ left: -480, behavior: 'smooth' }));
    wrap.querySelector('.scroll-btn-next')?.addEventListener('click', () => track.scrollBy({ left: 480, behavior: 'smooth' }));
  });

  // ── Countdown Timer ───────────────────────────────
  const cdEl = document.querySelector('[data-countdown]');
  if (cdEl) {
    const end = new Date(cdEl.dataset.countdown).getTime();
    function tick() {
      const diff = end - Date.now();
      if (diff <= 0) { cdEl.innerHTML = 'Sale Ended'; return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const pad = n => String(n).padStart(2, '0');
      cdEl.querySelectorAll('.cd-num')[0].textContent = pad(h);
      cdEl.querySelectorAll('.cd-num')[1].textContent = pad(m);
      cdEl.querySelectorAll('.cd-num')[2].textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  }

  // ── FAQ Accordion ─────────────────────────────────
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Mobile Nav Toggle ─────────────────────────────
  document.querySelector('.nav-toggle')?.addEventListener('click', () => {
    document.querySelector('.site-nav').classList.toggle('open');
  });

  // ── Cart Count ────────────────────────────────────
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('.cart-badge').forEach(b => b.textContent = cart.item_count || 0);
  }).catch(() => {});

  // ── Product Thumbnail Gallery ─────────────────────
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      const main = document.querySelector('.product-main-img img');
      if (src && main) main.src = src.replace('_72x72', '_900x900');
    });
  });

  // ── Contact Form Handling ─────────────────────────
  // Shopify handles form submission natively via {% form 'contact' %}

});
